export interface IDisposable {
    dispose(): void;
}

export class DisposableEventAggregator {
    #listeners = new Map<string, Set<(data: unknown) => void>>();

    public subscribe<T = unknown>(event: string, callback: (data: T) => unknown): IDisposable {
        if (!this.#listeners.has(event)) {
            this.#listeners.set(event, new Set());
        }

        const callbacks = this.#listeners.get(event);

        const wrappedCallback = (data: unknown) => {
            callback(data as T);
        };

        if (callbacks) {
            callbacks.add(wrappedCallback);
        }

        return {
            dispose: () => {
                if (callbacks) {
                    callbacks.delete(wrappedCallback);
                }
                if (callbacks && callbacks.size === 0) {
                    this.#listeners.delete(event);
                }
            },
        };
    }

    public subscribeOnce<T = unknown>(event: string, callback: (data: T) => unknown): IDisposable {
        const wrapper = (data: T) => {
            callback(data);
            disposable.dispose();
        };

        const disposable = this.subscribe(event, wrapper);
        return disposable;
    }

    public publish<T = unknown>(event: string, data?: T): void {
        const callbacks = this.#listeners.get(event);
        if (callbacks) {
            const publishedCallbacks = [...callbacks];
            for (const callback of publishedCallbacks) {
                if (callbacks.has(callback)) {
                    callback(data);
                }
            }
        }
    }

    public dispose(): void {
        this.#listeners.clear();
    }
}
